import * as tslib_1 from "tslib";
import { NgZone } from "@angular/core";
import { FirebaseX } from '@ionic-native/firebase-x/ngx';
import { Platform, NavController } from '@ionic/angular';
import { AppService } from './app.service';
import { LogService } from "./log.service";
var NotificationService = /** @class */ (function () {
    function NotificationService(firebaseX, platform, appService, navCtrl, ngZone, logService) {
        this.firebaseX = firebaseX;
        this.platform = platform;
        this.appService = appService;
        this.navCtrl = navCtrl;
        this.ngZone = ngZone;
        this.logService = logService;
        this.leadId = null;
        this.active = false;
        this.followUpAlert = false;
        this.whatsAppAlert = false;
        this.notificationTitle = "";
        this.link = "";
        this.message = "";
        this.hasWhatsAppPhone = false;
    }
    Object.defineProperty(NotificationService.prototype, "canWork", {
        get: function () { return this.platform.is("cordova"); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationService.prototype, "isAndroid", {
        get: function () { return this.platform.is("android"); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationService.prototype, "isIOS", {
        get: function () { return this.platform.is("ios"); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationService.prototype, "isFirebasePluginAvailable", {
        // Check that native Firebase plugin is actually available (especially on iOS,
        // where cordova-plugin-firebasex requires cordova-ios >= 7 and may not be installed)
        get: function () {
            var w = window;
            // cordova-plugin-firebasex clobbers `FirebasePlugin`
            if (w && w.FirebasePlugin) {
                return true;
            }
            // Fallback: older/alternative refs
            if (w && w.cordova && w.cordova.plugins && (w.cordova.plugins.firebase || w.cordova.plugins.firebaseMessaging)) {
                return true;
            }
            return false;
        },
        enumerable: true,
        configurable: true
    });
    NotificationService.prototype.subscribe = function (userId, hasWhatsAppPhone) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var pluginAvailable, err_1, msg;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.hasWhatsAppPhone = hasWhatsAppPhone;
                        return [4 /*yield*/, this.platform.ready()];
                    case 1:
                        _a.sent();
                        if (!this.canWork) return [3 /*break*/, 6];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        pluginAvailable = this.isFirebasePluginAvailable;
                        this.logService.add("canWork. userId: " + userId + ", pluginAvailable: " + pluginAvailable);
                        return [4 /*yield*/, this.firebaseX.subscribe("fix-" + userId).then(function (res) { })];
                    case 3:
                        _a.sent();
                        this.logService.add("check hasPermission");
                        this.firebaseX.hasPermission().then(function (hasPerm) {
                            _this.logService.add("hasPerm: " + hasPerm);
                            if (!hasPerm) {
                                _this.firebaseX.grantPermission().then(function (permissionGranted) { });
                                _this.logService.add("grantPermission");
                            }
                        });
                        if (this.isAndroid) {
                            this.logService.add("isAndroid");
                            this.firebaseX.onTokenRefresh().subscribe(function (token) {
                                _this.logService.add("onTokenRefresh success: " + token);
                            });
                            this.logService.add("onTokenRefresh");
                            this.firebaseX.getToken().then(function (token) {
                                _this.logService.add("getToken success: " + token);
                            });
                            this.logService.add("getToken");
                        }
                        else if (this.isIOS) {
                            this.logService.add("isIOS");
                            // TEMP block (as in Android)
                            this.firebaseX.onTokenRefresh().subscribe(function (token) {
                                _this.logService.add("onTokenRefresh success: " + token);
                            });
                            this.logService.add("onTokenRefresh");
                            this.firebaseX.getToken().then(function (token) {
                                _this.logService.add("getToken success: " + token);
                            });
                            this.logService.add("getToken");
                            this.firebaseX.onApnsTokenReceived().subscribe(function (token) {
                                _this.logService.add("onApnsTokenReceived success: " + token);
                            });
                            this.logService.add("onApnsTokenReceived");
                            this.firebaseX.getAPNSToken().then(function (token) {
                                _this.logService.add("getAPNSToken success: " + token);
                            });
                            this.logService.add("getAPNSToken");
                        }
                        this.logService.add("before onMessageReceived");
                        this.firebaseX.onMessageReceived().subscribe(function (msg) {
                            _this.logService.add("onMessageReceived: " + JSON.stringify(msg));
                            if ((msg.messageType === 'notification' || msg.messageType == 'data') && msg.leadClientId > 0) {
                                _this.logService.add("notification leadClientId");
                                _this.leadId = msg.leadClientId;
                                var hasWhatsAppPhone_1 = _this.hasWhatsAppPhone;
                                setTimeout(function () {
                                    _this.appService.leadClientsGroup.forEach(function (x) {
                                        var lc = x.leadClients.find(function (c) { return c.id == msg.leadClientId; });
                                        if (lc) {
                                            if (!lc.countOfWhatsAppMessages) {
                                                lc.countOfWhatsAppMessages = 0;
                                            }
                                            lc.countOfWhatsAppMessages++;
                                        }
                                    });
                                }, 100);
                                if (msg.tap) {
                                    _this.ngZone.run(function () {
                                        if (hasWhatsAppPhone_1) {
                                            _this.navCtrl.navigateForward("/leadClients/" + msg.leadClientId + "/whatsapp");
                                        }
                                        else {
                                            _this.navCtrl.navigateForward("/leadClients/" + msg.leadClientId);
                                        }
                                    });
                                }
                                else {
                                    _this.ngZone.run(function () {
                                        if (hasWhatsAppPhone_1) {
                                            _this.notificationTitle = msg.notification.title;
                                            _this.message = msg.notification.body;
                                            _this.whatsAppAlert = true;
                                        }
                                        else {
                                            _this.leadId = msg.leadClientId;
                                            _this.link = "/leadClients/" + msg.leadClientId;
                                            _this.active = true;
                                        }
                                    });
                                }
                            }
                            else if ((msg.messageType === "notification" || msg.messageType == 'data') && msg.leadId > 0) {
                                _this.logService.add("notification leadId");
                                _this.leadId = msg.leadId;
                                if (msg.tap) {
                                    _this.ngZone.run(function () {
                                        // if (this.isAndroid) {
                                        //     (<any>window).plugins.bringtofront();
                                        // }
                                        _this.navCtrl.navigateForward("/leadClients/" + msg.leadId);
                                    });
                                }
                                else {
                                    _this.ngZone.run(function () {
                                        _this.active = true;
                                    });
                                }
                            }
                            else if ((msg.messageType === 'notification' || msg.messageType == 'data') && msg.followUpLeadId > 0) {
                                _this.logService.add("notification followUpLeadId");
                                _this.leadId = msg.followUpLeadId;
                                if (msg.tap || msg.tap == "background") {
                                    _this.ngZone.run(function () {
                                        // if (this.isAndroid) {
                                        //     (<any>window).plugins.bringtofront();
                                        // }
                                        _this.navCtrl.navigateForward("/leadClients/" + msg.followUpLeadId);
                                    });
                                }
                                else {
                                    _this.ngZone.run(function () {
                                        _this.followUpAlert = true;
                                    });
                                }
                            }
                        });
                        return [3 /*break*/, 5];
                    case 4:
                        err_1 = _a.sent();
                        msg = this.appService.getErrorMessage(err_1);
                        // Ignore missing plugin on platforms where Firebase is not available,
                        // so the app does not show a generic error dialog on iOS.
                        if (typeof msg === "string" && msg.indexOf("plugin_not_installed") !== -1) {
                            this.logService.add("Firebase plugin not installed on this platform, skipping subscription. Details: " + msg);
                            return [2 /*return*/];
                        }
                        this.logService.add("Firebase subscription error. " + msg);
                        this.appService.showError("Firebase subscription error", msg);
                        return [3 /*break*/, 5];
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        this.logService.add("NO canWork (not running under Cordova). userId: " + userId + ", platforms: " + this.platform.platforms());
                        _a.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    NotificationService.prototype.unsubscribe = function (userId) {
        if (!this.canWork) {
            return;
        }
        if (!this.isFirebasePluginAvailable) {
            this.logService.add("Cannot unsubscribe from Firebase topic on this platform \u2013 Firebase plugin not available. userId: " + userId);
            return;
        }
        this.firebaseX.unsubscribe("fix-" + userId);
    };
    return NotificationService;
}());
export { NotificationService };
